import React from "react"
import { Badge, Button } from "reactstrap"
import { CanView } from "components/Common/CanView"
import { ACCESS } from "constants/accessPermissions"

const AccountVendorPaymentHeader = ({
  handleAddNewClick,
  handleRefresh,
  resetParams,
  isRefetching,
  hasActiveFilters,
  total,
}) => {
  return (
    <div className="d-flex align-items-center">
      <h5 className="mb-0 mt-3 card-title flex-grow-1">
        Total <Badge className="badge-soft-info">{total ?? 0}</Badge>
      </h5>
      <div className="flex-shrink-0">
        <CanView access={[ACCESS.ACCOUNT_VENDOR_PAYMENT.ADD]}>
          <Button color="primary" onClick={handleAddNewClick}>Add New</Button>
        </CanView>
        <Button color="light" onClick={handleRefresh} className="ms-1">
          <i className={`mdi mdi-refresh ${isRefetching ? "mdi-spin" : ""}`} />
        </Button>
        {hasActiveFilters && (
          <Button color="danger" onClick={resetParams} className="ms-1">Reset Filters</Button>
        )}
      </div>
    </div>
  )
}

export default AccountVendorPaymentHeader
